import { render, staticRenderFns } from "./MyHead.vue?vue&type=template&id=2e014b97&scoped=true"
import script from "./MyHead.vue?vue&type=script&lang=js"
export * from "./MyHead.vue?vue&type=script&lang=js"
import style0 from "./MyHead.vue?vue&type=style&index=0&id=2e014b97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e014b97",
  null
  
)

export default component.exports